$(document).ready(function() {
    function setupMenu() {
        if ($(window).width() > 991) {
            $('.header ul li details').on('mouseenter', function() {
                $('details').removeAttr('open');
                $(this).attr('open', true);
                $('details .header__menu-item').removeAttr('aria-expanded');
                $(this).find('.header__menu-item').attr('aria-expanded', true);
            });

            $('details').on('mouseleave', function() {
                $(this).removeAttr('open');
                $(this).find('.header__menu-item').removeAttr('aria-expanded');
            });
        } else {
            $('.header ul li details').off('mouseenter mouseleave');
        }
    }

    setupMenu();

    $(window).resize(function() {
        setupMenu();
    });

     $(".header ul.menu-drawer__menu.has-submenu.list-menu li details summary").click(function(){
    $(this).toggleClass("moving");
  });
  
});

$(document).ready(function() {
  if ($(".gradient").hasClass("cart__warnings")) {
    alert();
    $(".gradient").css("background", "white");
  }
});




















  








